import debug from 'Helper/debugHelpers'
import globalConfig from 'Helper/configHelpers'
import { ApiException, jsonResponseHandler, errorResponseHandler } from 'Helper/API/ResponseHandlers.js'

const makeRequest = (type, route, data = null) => {
  const baseUrl = globalConfig.api_base_url
  // baseUrl is forced to https no mater what to eliminate risk of sending
  // credentials in plain text over http due to misconfiguration.
    .replace('http://', 'https://')

  const url = `${baseUrl}/v1/auth${route}`
  debug.log(`making API call to ${url}`, debug.logLevels.AUTH, 'info')
  const headers = {
    Accept: 'application/json',
    xtractAppId: globalConfig.client_id,
    'X-CSRF-TOKEN': globalConfig.getCsrfToken()
  }

  const request = new Request(
    url,
    {
      credentials: 'same-origin',
      method: type,
      mode: 'cors',
      cache: 'no-cache',
      body: data,
      headers: new Headers(headers)
    }
  )
  return fetch(request)
}

export const forgotPassword = (email) => {
  const formData = new FormData()
  formData.append('email', email)
  return makeRequest('POST', '/forgot-password', formData)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const lockUserAccount = (lockId, signature) => {
  const url = `/access/${lockId}?signature=${signature}`
  return makeRequest('DELETE', url)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const login = (displayname, password) => {
  const formData = new FormData()
  formData.append('password', password)
  formData.append('displayname', displayname)

  return makeRequest('POST', '/login', formData)
    .then(result => {
      if (result.status === 200) {
        result.clone()
          .json()
          .then(data => {
            // if it was a successful login (excluding two factor which would make the user not logged in yet)
            // then update the csrf_token
            if (data.data.login.csrf_token) {
              globalConfig.setCsrfToken(data.data.login.csrf_token)
            }
          })
      }
      return jsonResponseHandler(result)
    })
    .catch(error => errorResponseHandler(error))
}

export const adminLogin = (displayname, password) => {
  const formData = new FormData()
  formData.append('password', password)
  formData.append('displayname', displayname)

  return makeRequest('POST', '/xtract/login', formData)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const passwordReset = (token, email, expires, signature, password, passwordConfirmation) => {
  const formData = new FormData()
  formData.append('password', password)
  formData.append('password_confirmation', passwordConfirmation)
  
  const url = `/reset-password?email=${encodeURIComponent(email)}&expires=${encodeURIComponent(expires)}&token=${encodeURIComponent(token)}&signature=${encodeURIComponent(signature)}`
  return makeRequest('POST', url, formData)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const enable2Fa = () => {
  return makeRequest('POST', '/user/two-factor-authentication')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const disable2Fa = () => {
  return makeRequest('DELETE', '/user/two-factor-authentication')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const get2FaQr = () => {
  return makeRequest('GET', '/user/two-factor-qr-code')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const get2FaRecoveryCodes = () => {
  return makeRequest('GET', '/user/two-factor-recovery-codes')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const regenerate2FaRecoveryCodes = () => {
  return makeRequest('POST', '/user/two-factor-recovery-codes')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const verify2Fa = (code, recoveryCode) => {
  const formData = new FormData()
  if (code) {
    formData.append('code', code)
  } else if (recoveryCode) {
    formData.append('recovery_code', recoveryCode)
  }

  return makeRequest('POST', '/two-factor-challenge', formData).then(result => {
    if (result.status === 200) {
      result.clone()
        .json()
        .then(data => {
          // if it was a successful login (excluding two factor which would make the user not logged in yet)
          // then update the csrf_token
          if (data.data['two-factor-challenge'].csrf_token) {
            globalConfig.setCsrfToken(data.data['two-factor-challenge'].csrf_token)
          }
        })
    }
    return result
    // 204 === success 422 === failure
  })
}

export const resendVerificationEmail = (userId = null) => {
  const formData = new FormData()
  if (userId) {
    formData.append('user_id', userId)
  }
  return makeRequest('POST', '/email/verification-notification', formData)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const verifyEmail = (id, hash, expires, signature) => {
  return makeRequest('GET', `/email/verify/${id}/${hash}?expires=${expires}&signature=${signature}`)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}
export const verifyPassword = (password) => {
  const formData = new FormData()
  formData.append('password', password)

  return makeRequest('POST', '/user/confirm-password', formData)
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}

export const logout = () => {
  return makeRequest('POST', '/logout')
    .then(data => jsonResponseHandler(data))
    .catch(error => errorResponseHandler(error))
}
